// extracted by mini-css-extract-plugin
module.exports = {"divider":"AttachmentAddPopup_divider__1Thiv","menu":"AttachmentAddPopup_menu__23FMj","menuItem":"AttachmentAddPopup_menuItem__3BfXG","tip":"AttachmentAddPopup_tip__1bVwE"};